import { render } from "./EditBoitePostalePage.vue?vue&type=template&id=af700d5e&ts=true"
import script from "./EditBoitePostalePage.vue?vue&type=script&lang=ts"
export * from "./EditBoitePostalePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__